import { render } from "./Inventory_TransferCheck_Dialog.vue?vue&type=template&id=3500516f&ts=true"
import script from "./Inventory_TransferCheck_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_TransferCheck_Dialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__